/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const presignedPutResultSchema = z.object({
  fields: z.object({}).catchall(z.string()),
  key: z.string(),
  url: z.string(),
});
